import React, { useState, useEffect, useContext } from 'react';
import Loading from '../Loading';
import { Container, Row, Col } from 'react-bootstrap';
import { useLocation, useHistory } from "react-router-dom";
import ScheduleBox from './ScheduleBox';
import { scheduleEmailsGet, scheduleSmsGet, scheduleTemplateKeys } from '../../api';
import { somethingWentWrongNotice } from '../UI/Notifications';
import { UserContext } from 'context/User';

const ScheduleTemplateEdit = ({ setTrigger, trigger }) => {
  const useQuery = () => new URLSearchParams(useLocation().search);
  const { setIsLoggedIn, setUser } = useContext(UserContext);
  const query = useQuery();
  const id = query.get("template_id");
  const type = query.get("type");
  const [loading, setLoading] = useState(false);
  const [messageInfo, setMessageInfo] = useState({});
  const [templateKeys, setTemplateKeys] = useState({});
  const history = useHistory();
  const title = type === 'email' && 'Edit Scheduled Email' || type === 'sms' && 'Edit Scheduled SMS'; 

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Inbox");
    }
    setLoading(false);
  }

  useEffect(() => {
    setLoading(true);
    switch (type) {
      case 'email':
        scheduleEmailRequest()
        scheduleTemplateKeysRequest()
        break;
      case 'sms':
        scheduleSmsRequest()
        scheduleTemplateKeysRequest()
        break;
      default:
        setLoading(false);
    }
    setTrigger(!trigger);
  }, []);

  const scheduleEmailRequest = () => {
    scheduleEmailsGet(id)
      .then(response => {
        setMessageInfo(response.data);
        setLoading(false);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
        setLoading(false);
      })
  }

  const scheduleSmsRequest = () => {
    scheduleSmsGet(id)
      .then(response => {
        setMessageInfo(response.data);
        setLoading(false);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
        setLoading(false);
      })
  }

  const scheduleTemplateKeysRequest = () => {
    scheduleTemplateKeys()
      .then(response => {
        setTemplateKeys(response.data);
        setLoading(false);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
        setLoading(false);
      })
  }

  return (
    <section className="section-spaces">
      <Container>
        <Row>
          <Col>
            <h3 className="mb-5">
              {title}
            </h3>
          </Col>
        </Row>
        {Boolean(Object.keys(messageInfo).length) &&  
        <Row>
          <Col>
            <ScheduleBox 
              messageInfo={messageInfo}
              templateKeys={templateKeys}
              type={type}
              handleDefaultStatusCodes={handleDefaultStatusCodes}
              setLoading={setLoading}
            />
          </Col>
        </Row>
        }
      </Container>
      {loading && <Loading />}
    </section>  
  )
}

export default ScheduleTemplateEdit;